import { InstructorMap, Question } from './types';

export const SAFETY_INDUCTION_PDF_URL = 'https://drive.google.com/file/d/1PFc29-dABxbc3UJex_PobQac31BygMbm/view?usp=drive_link';

export const AREAS = [
  "Yard Cakung",
  "Yard Sukapura",
  "Yard Jababeka"
];

export const INSTRUCTORS: InstructorMap = {
  "Yard Cakung": ["Chairuloh", "Tri Andini Wiyananto", "M Syahrul"],
  "Yard Sukapura": ["Helmalya Regita Pramesti", "Joe Devin", "Titto M", "Alroy", "Irfan Saputra"],
  "Yard Jababeka": ["Budi Miradi"]
};

export const INITIAL_QUESTIONS: Question[] = [
  { 
    id: 'q1', 
    text: 'Apakah anda sudah mengisi daftar hadir pada absensi safety induction?',
    textEn: 'Have you filled out the safety induction attendance list?'
  },
  { 
    id: 'q2', 
    text: 'Apakah anda sudah tau tentang EHS?',
    textEn: 'Do you know about EHS (Environment, Health, and Safety)?'
  },
  { 
    id: 'q3', 
    text: 'Apakah anda sudah mengikuti safety induction yang di berikan oleh ESR Officer MKT Divisi ?',
    textEn: 'Have you attended the safety induction provided by the MKT Division ESR Officer?'
  },
  { 
    id: 'q4', 
    text: 'Apakah anda sudah jelas dengan pengarahan dari petugas tentang safety induction?',
    textEn: 'Is the safety induction briefing provided by the officer clear to you?'
  },
  { 
    id: 'q5', 
    text: 'Apakah anda sudah paham jalur evakuasi jika terjadi situasi darurat?',
    textEn: 'Do you understand the evacuation route in case of an emergency?'
  },
  { 
    id: 'q6', 
    text: 'Apakah anda sudah tahu tempat berkumpul jika terjadi situasi darurat?',
    textEn: 'Do you know the assembly point in case of an emergency?'
  },
  { 
    id: 'q7', 
    text: 'Apakah anda sudah tahu cara menggunakan APD (Alat Pelindung Diri) yang benar?',
    textEn: 'Do you know how to use PPE (Personal Protective Equipment) correctly?'
  },
  { 
    id: 'q8', 
    text: 'Apakah anda tahu potensi bahaya dan factor bahaya yang ada di area kerja ?',
    textEn: 'Do you know the potential hazards and risk factors in the work area?'
  },
  { 
    id: 'q9', 
    text: 'Apakah anda sudah paham dengan rambu-rambu keselamatan di area kerja ?',
    textEn: 'Do you understand the safety signs in the work area?'
  },
  { 
    id: 'q10', 
    text: 'Apakah anda dalam keadaan sehat?',
    textEn: 'Are you in good health?'
  },
  { 
    id: 'q11', 
    text: 'Selama berada di lingkungan kerja PT United Tractors khususnya di area Marketing Divisi anda siap untuk melaksanakan peraturan yang telah kami buat?',
    textEn: 'While in the PT United Tractors work environment, especially in the Marketing Division area, are you ready to comply with the regulations we have established?'
  },
];

export const DEFAULT_POST_TEST_QUESTIONS = [
  {
    id: 'pt-1',
    text: 'Berapakah batas kecepatan maksimal berkendara (mobil/motor) di area Yard?',
    options: ['10 km/jam', '20 km/jam', '30 km/jam', '40 km/jam'],
    correctOptionIndex: 0,
    points: 10
  },
  {
    id: 'pt-2',
    text: 'Apa kepanjangan dari singkatan EHS di PT United Tractors?',
    options: [
      'Emergency, Hazard, and Security',
      'Environment, Health, and Safety',
      'Environment, Housekeeping, and Safety',
      'Equipment, Health, and Standard'
    ],
    correctOptionIndex: 1,
    points: 10
  },
  {
    id: 'pt-3',
    text: 'Alat Pelindung Diri (APD) standar wajib apa yang harus digunakan saat memasuki area Yard?',
    options: [
      'Helm keselamatan dan Rompi reflektif (Safety Helmet & Safety Vest)',
      'Kacamata Hitam dan Rompi biasa',
      'Sandal jepit dan Topi kasual',
      'Tidak perlu menggunakan APD apa pun'
    ],
    correctOptionIndex: 0,
    points: 10
  },
  {
    id: 'pt-4',
    text: 'Di mana area berkumpul (Assembly Point) jika terjadi keadaan darurat di area Marketing Divisi?',
    options: [
      'Tempat Parkir Motor Belakang',
      'Lobi Utama Gedung',
      'Titik Kumpul yang ditandai dengan rambu hijau di area terbuka',
      'Kantin Karyawan'
    ],
    correctOptionIndex: 2,
    points: 10
  },
  {
    id: 'pt-5',
    text: 'Warna rambu keselamatan apakah yang melambangkan arah jalur evakuasi penunjuk keselamatan?',
    options: ['Merah', 'Kuning', 'Hijau', 'Biru'],
    correctOptionIndex: 2,
    points: 10
  },
  {
    id: 'pt-6',
    text: 'Warna rambu keselamatan apakah yang melambangkan larangan keras (misalnya dilarang merokok)?',
    options: ['Merah', 'Kuning', 'Hijau', 'Biru'],
    correctOptionIndex: 0,
    points: 10
  },
  {
    id: 'pt-7',
    text: 'Apa tindakan pertama yang harus dilakukan jika mendengar alarm / sirine keadaan darurat?',
    options: [
      'Berlari panik mencari jalan keluar tercepat sendirian',
      'Mengambil dokumen penting, memotret, dan tetap santai di ruangan',
      'Menghentikan seluruh aktivitas kerja, mematikan peralatan listrik, dan berjalan dengan tertib mengikuti jalur evakuasi menuju Assembly Point',
      'Mencari tempat bersembunyi di bawah meja'
    ],
    correctOptionIndex: 2,
    points: 10
  },
  {
    id: 'pt-8',
    text: 'Apakah tamu/visitor diijinkan melakukan aktivitas teknis atau pekerjaan mandiri tanpa didampingi oleh petugas internal/safety officer?',
    options: [
      'Ya, bebas jika sudah membaca selebaran keselamatan',
      'Tidak diijinkan sama sekali, wajib selalu didampingi oleh Penanggung Jawab Kegiatan / Safety Officer',
      'Ya jika pekerjaan tersebut ringan',
      'Boleh asal membawa peralatan sendiri dari rumah'
    ],
    correctOptionIndex: 1,
    points: 10
  },
  {
    id: 'pt-9',
    text: 'Jenis APD spesifik apa yang berfungsi mencegah cedera pada kepala dari kejatuhan objek atau benturan benda keras?',
    options: ['Safety Shoes', 'Safety Helmet / Helm Keselamatan', 'Safety Goggles', 'Ear Plug'],
    correctOptionIndex: 1,
    points: 10
  },
  {
    id: 'pt-10',
    text: 'Apa arti dari rambu segitiga berwarna latar kuning dengan simbol hitam?',
    options: [
      'Informasi umum / Petunjuk',
      'Peringatan rintangan atau potensi bahaya',
      'Instruksi wajib dilaksanakan',
      'Tanda larangan'
    ],
    correctOptionIndex: 1,
    points: 10
  }
];

